import {
    AppstoreFilled,
    ClockCircleOutlined,
    HeartFilled,
    ThunderboltOutlined,
} from '@ant-design/icons';
import { Button, List, Modal, Space, Switch, Typography } from 'antd';
import { useSelector } from 'react-redux';
import CustomerSearch from '../../../components/ui/CustomerSearch';

const { Text } = Typography;

const FilterView = ({
    open,
    onClear,
    onClose,
    isClearable,
    isCustomerDisable,

    onCustomerChange,
    onToggleFavorites,
    onToggleRecent,
    onToggleOffer,
    onToggleCategory,
}) => {
    const { customer, favourite, recent, offer } = useSelector((state) => state.filtersSlice);

    const toggleCategoryModal = () => {
        onToggleCategory?.();
        onClose?.();
    };

    return (
        <Modal
            open={open}
            title="Filter Options"
            okText="Apply"
            cancelText={isClearable ? 'Clear All' : 'Cancel'}
            onOk={onClose}
            cancelButtonProps={{
                danger: isClearable,
            }}
            onCancel={isClearable ? onClear : onClose}
        >
            <List
                itemLayout="horizontal"
                dataSource={[
                    { type: 'customer' },
                    { type: 'favourite' },
                    { type: 'recent' },
                    { type: 'category' },
                ]}
                renderItem={(item) => {
                    if (item.type === 'customer')
                        return (
                            <List.Item>
                                <CustomerSearch
                                    size="large"
                                    placeholder="Search customer..."
                                    value={customer}
                                    onChange={onCustomerChange}
                                    disabled={isCustomerDisable}
                                />
                            </List.Item>
                        );

                    if (item.type === 'favourite')
                        return (
                            <List.Item>
                                <Space className="w-full justify-content-between">
                                    <Space align="center">
                                        <HeartFilled style={{ color: '#ff4d6d' }} />
                                        <Text strong>Favourites</Text>
                                    </Space>
                                    <Switch checked={favourite} onChange={onToggleFavorites} />
                                </Space>
                            </List.Item>
                        );

                    if (item.type === 'recent' && customer)
                        return (
                            <List.Item>
                                <Space className="w-full justify-content-between">
                                    <Space align="center">
                                        <ClockCircleOutlined style={{ color: '#1677ff' }} />
                                        <Text strong>Recent Items</Text>
                                    </Space>
                                    <Switch checked={recent} onChange={onToggleRecent} />
                                </Space>
                            </List.Item>
                        );

                    if (item.type === 'offer')
                        return (
                            <List.Item>
                                <Space className="w-full justify-content-between">
                                    <Space align="center">
                                        <ThunderboltOutlined style={{ color: '#ff4d4f' }} />
                                        <Text strong>Offers</Text>
                                    </Space>
                                    <Switch checked={offer} onChange={onToggleOffer} />
                                </Space>
                            </List.Item>
                        );

                    if (item.type === 'category')
                        return (
                            <List.Item>
                                <Space className="w-full justify-content-between">
                                    <Space align="center">
                                        <AppstoreFilled />
                                        <Text strong>Categories</Text>
                                    </Space>
                                    <Button variant="filled" color="default" onClick={toggleCategoryModal}>
                                        Open
                                    </Button>
                                </Space>
                            </List.Item>
                        );
                    return null;
                }}
            />
        </Modal>
    );
};

export default FilterView;
